import { render } from "./Page2.vue?vue&type=template&id=02cb7e41&scoped=true"
import script from "./Page2.vue?vue&type=script&lang=js"
export * from "./Page2.vue?vue&type=script&lang=js"

import "./Page2.vue?vue&type=style&index=0&id=02cb7e41&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-02cb7e41"

export default script